import request, { authOptions } from 'api/requestUtils'
import config from 'constants/config'

const EVALUATE_PATH = '/api/lab/v2/evaluate'
const EVALUATE_TIMEOUT_MS = 1000

export async function evaluateLabV2(token: string | undefined, enabled: boolean): Promise<void> {
  if (!enabled || !config.LAB_V2_ENABLED) {
    return
  }

  try {
    await request.post(
      EVALUATE_PATH,
      { attributes: {} },
      {
        ...authOptions(token),
        timeout: EVALUATE_TIMEOUT_MS,
        // The evaluate body only allows `attributes`. This keeps the shared client from adding `brand`.
        excludeBrand: true,
      },
    )
  } catch {
    // The document still renders when Lab v2 is down or slow.
  }
}
